"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _UserAvatar = _interopRequireDefault(require("../User/UserAvatar"));

var TopicLastPost = function TopicLastPost(_ref) {
  var lastPostAuthor = _ref.lastPostAuthor,
      lastPostUrl = _ref.lastPostUrl,
      lastPostRelativeCreationDate = _ref.lastPostRelativeCreationDate;
  return (0, _preact.h)("span", {
    className: "thread-meta-item thread-meta-item--last-update thread-meta-item--hover-highlight"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: lastPostAuthor,
    extraClass: "avatar--XS thread-meta-item__icon",
    showRank: true
  }), (0, _preact.h)("a", {
    className: "qa-topic-meta-last-post-date-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(lastPostUrl)
  }, (0, _preact.h)("span", {
    className: "thread-meta-item__text"
  }, lastPostRelativeCreationDate)));
};

var _default = TopicLastPost;
exports.default = _default;